import service from '@/plugins/service'
import { createFormData } from '@/plugins/formData'

const base = 'auth/user'

export const getUserList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const searchUserList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}
export const searchUserListExclude = (current, pageSize, data) => {
  return service({
    url: `${base}/query/exclude/customer`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const searchUserByMobile = (mobile) => {
  return service({
    url: `${base}/query/mobile`,
    method: 'GET',
    params: {
      mobile
    }
  })
}

export const addUser = data => {
  return service({
    url: `${base}`,
    method: 'POST',
    data
  })
}

export const updateUser = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const removeUser = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const deleteLogo = userId => service({
  url: `${base}/logo/delete`,
  method: 'DELETE',
  params: {
    userId
  }
})

export const uploadLogo = o => {
  return service({
    url: `${base}/logo/upload`,
    method: 'POST',
    data: createFormData(o)
  })
}

export const updateAppVersions = data => service({
  url: `${base}/updateAppVersion`,
  method: "PUT",
  data
})